module.exports = __webpack_public_path__ + "static/media/workshop_rejected_emptystate.04e4c0fd.svg";